import { apiRequest } from "./api.client";

export interface ClinicTag {
  tag_id: string;
  name: string;
  created_at: string;
  patient_count: number;
}

export const TagsAPI = {
  /** All of this clinic's tags (even unused ones), with per-tag patient counts. */
  list(): Promise<ClinicTag[]> {
    return apiRequest<ClinicTag[]>("/patients/tags");
  },

  /** Create a standalone tag — idempotent (case-insensitive) if it already exists. */
  create(name: string): Promise<ClinicTag> {
    return apiRequest<ClinicTag>("/patients/tags", {
      method: "POST",
      body: JSON.stringify({ name }),
    });
  },

  /** Delete a tag clinic-wide — also removes it from every patient that has it. */
  delete(tagId: string): Promise<{ patients_updated: number }> {
    return apiRequest<{ patients_updated: number }>(`/patients/tags/${tagId}`, {
      method: "DELETE",
    });
  },
};
